const IconClose = () => {
  return (
    <path
      d="M6 6L18 18M18 6L6 18"
      stroke="currentColor"
      strokeWidth="1.7"
      data-icon="icon-close"
    />
  );
};

export default IconClose;
